const items = [
  { i: "🛡️", t: "No ads. No autoplay rabbit holes." },
  { i: "👀", t: "Every video filtered for educational value." },
  { i: "🔒", t: "COPPA-compliant. No data sold." },
];

function TrustStrip() {
  return (
    <section data-ga-section="trust_strip" className="bg-white border-y border-black/5">
      <div className="max-w-screen-lg mx-auto px-6 py-5 flex flex-wrap gap-x-8 gap-y-3 items-center justify-center text-darkrock/70 text-[13px]">
        {items.map((x, i) => (
          <div key={i} className="flex items-center gap-2">
            <span className="text-base">{x.i}</span>
            <span className="font-medium">{x.t}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default TrustStrip;
